import React, { memo, useMemo, useCallback } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { createUseStyles } from 'hoi-poi-ui';
import { Cfm, Icon, Web } from "./logos";
import styles from "../styles/LogoSidebar";
const useStyles = createUseStyles(styles, 'LogoSidebar');
var _ref2 = /*#__PURE__*/React.createElement(Icon, null);
const LogoSidebar = /*#__PURE__*/memo(_ref => {
  let {
    appName,
    className: classNameProp,
    customLogo,
    homeLink = '/',
    isExpanded = true
  } = _ref;
  const classes = useStyles();
  const rootClassName = classnames(classes.root, {
    [classes.isExpanded]: isExpanded
  }, classNameProp);
  const getLogo = useCallback((appName, logoProps) => ({
    cfm: /*#__PURE__*/React.createElement(Cfm, logoProps),
    web: /*#__PURE__*/React.createElement(Web, logoProps)
  })[appName], []);
  const rectangularProps = useMemo(() => {
    const rectangularClass = appName === 'web' ? classes.rectangularFM : classes.rectangularAdmin;
    return {
      className: rectangularClass
    };
  }, [appName, classes]);
  const square = useMemo(() => {
    if (customLogo !== null && customLogo !== void 0 && customLogo.square) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          backgroundImage: `url('${customLogo.square}'`
        },
        className: classes.customSquare
      });
    }
    return _ref2;
  }, [classes.customSquare, customLogo]);
  const rectangular = useMemo(() => {
    if (customLogo !== null && customLogo !== void 0 && customLogo.rectangular) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          backgroundImage: `url('${customLogo.rectangular}'`
        },
        className: classes.customRectangular
      });
    }
    return getLogo(appName, rectangularProps);
  }, [appName, classes.customRectangular, customLogo, getLogo, rectangularProps]);
  return /*#__PURE__*/React.createElement("a", {
    href: homeLink,
    className: rootClassName
  }, square, rectangular);
});
process.env.NODE_ENV !== "production" ? LogoSidebar.propTypes = {
  appName: PropTypes.oneOf(['web', 'cfm']).isRequired,
  className: PropTypes.string,
  homeLink: PropTypes.string,
  isExpanded: PropTypes.bool
} : void 0;
export default LogoSidebar;